<!--<div class="app-content content">
    <div class="content-wrapper">
        <div class="content-header row mb-1">
        </div>
        <div class="content-body">
            <section class="flexbox-container">
                <div class="col-12 d-flex align-items-center justify-content-center">
                    <div class="col-md-4 col-10 box-shadow-2 p-0">
                      <div class="card border-grey border-lighten-3 px-1 py-1 m-0">
                        <div class="card-title text-center">
                          <img src="assets/custom/images/abg/abglogo512.png" alt="branding logo">
                          </div>
                        <div class="card-content">-->
<!--<form name="forgotpwdForm" #forgotpwdForm="ngForm" (ngSubmit)="SavenewPassword(forgotpwdForm)">
<div class="form-group position-relative has-icon-R">
  <select type="text" name="vertificationMethod" required (change)="selectedMethodisenabled($event)" class="form-control" #vertificationMethod="ngModel"
          [ngClass]="{ 'is-invalid': forgotpwdForm.submitted && vertificationMethod.errors }"
          [(ngModel)]="forgotpwd.vertificationMethod">
    <option [ngValue]="undefined" [disabled]="true">Choose Vertification Method</option>
    <option value="Email">Email</option>
    <option value="MobileNumber">MobileNumber</option>
  </select>
</div>
<div class="form-group position-relative has-icon-R">
  <input type="text" name="mobileNumber" required numberValidator maxlength="10" [disabled]="!mobilenumbers" (change)="getEmailID($event)" [ngClass]="{ 'is-invalid': forgotpwdForm.submitted && mobileNumber.errors }" minlenth="10" #mobileNumber="ngModel" placeholder="Mobile Number" class="form-control" [(ngModel)]="forgotpwd.mobileNumber" />
</div>
<div class="form-group position-relative has-icon-R">
  <input type="text" name="email" class="form-control" required email [disabled]="!emails" (change)="getMobileNumber($event)" [ngClass]="{ 'is-invalid': forgotpwdForm.submitted && email.errors }" maxlength="35" #email="ngModel" pattern="^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$" whiteSpaceValidator placeholder="Enter EmailID" [(ngModel)]="forgotpwd.email" />
  <div *ngIf="forgotpwdForm.submitted && email.errors" class="invalid-feedback">
    <div *ngIf="email.errors['required']"></div>
  </div>
</div>
<div class="form-group position-relative has-icon-R">
  <input type="date" name="dateOfBirth" required data-date-format="DD MMMM YYYY" class="form-control" disabled [(ngModel)]="forgotpwd.dateOfBirth" />
</div>
<div class="form-group position-relative has-icon-R">
  <select type="text" name="securityQuestion" class="form-control" #securityQuestion="ngModel"
          [ngClass]="{ 'is-invalid': forgotpwdForm.submitted && securityQuestion.errors }"
          [(ngModel)]="forgotpwd.securityQuestion">
    <option [ngValue]="undefined" [disabled]="true">Choose Security Question</option>
    <option value="Your mother's maiden name?">Your mother's maiden name?</option>
    <option value="In what city were you born?">In what city were you born?</option>
    <option value="Your favorite pet's name?">Your favorite pet's name?</option>
  </select>
</div>
<div class="form-group position-relative has-icon-R">
  <input type="text" name="securityQuestionOther" maxlength="50" [ngClass]="{ 'is-invalid': forgotpwdForm.submitted && securityQuestionOther.errors }" #securityQuestionOther="ngModel" placeholder="Enter Security Question Other(If Any)" class="form-control" [(ngModel)]="forgotpwd.securityQuestionOther" />
</div>
<div class="form-group position-relative has-icon-R">
  <input type="text" name="securityAnswer" required maxlength="50" [ngClass]="{ 'is-invalid': forgotpwdForm.submitted && securityAnswer.errors }" #securityAnswer="ngModel" placeholder="Answer for your Security Question" class="form-control" [(ngModel)]="forgotpwd.securityAnswer" />
</div>
<div class="form-group position-relative has-icon-R">
  <input type="password" name="newPassword" required maxlength="20" minlength="10" [ngClass]="{ 'is-invalid': forgotpwdForm.submitted && newPassword.errors }" #newPassword="ngModel" placeholder="Enter New Password" class="form-control" [(ngModel)]="forgotpwd.newPassword" />
</div>
<div class="form-group position-relative has-icon-R">
  <input type="password" name="confirmNewPassword" required maxlength="20" minlength="10" (change)="CheckConfirmPassword($event)" [ngClass]="{ 'is-invalid': forgotpwdForm.submitted && confirmNewPassword.errors }" #confirmNewPassword="ngModel" placeholder="Enter Confirm Password" class="form-control" [(ngModel)]="forgotpwd.confirmNewPassword" />
</div>
<div style="text-align:center" class="form-group position-relative has-icon-R">
  <button type="button" [disabled]="!otpclick" class="btn btn-secondary btn-min-width mr-1 mb-1" (click)="GenerateOTP()">Generate OTP</button>
</div>
<div class="form-group position-relative has-icon-R">
  <input type="text" name="verificationCode" required disabled placeholder="Verification Code" class="form-control" [(ngModel)]="forgotpwd.verificationCode" />
</div>
<button type="submit" [disabled]="!forgotpwdForm.valid" class="btn btn-outline-info btn-block">
  Forgot Password
</button>
<br />-->
<!--<div class="form-group row">-->
<!--<div class="col-md-6 col-12">
  <a [routerLink]="['/login']" class="card-link"> Go to Login?</a>
</div>-->
<!--</div>-->
<!--</form>-->
<!--<div class="card-body">
                          <form [formGroup]="forgetPasswordForm" (ngSubmit)="onSubmit()">
                            <div *ngIf="!otpSent" class="form-group">
                              <label for="email">Email address</label>
                              <input type="email" formControlName="email" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
                              <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                <div *ngIf="f.email.errors.required">Email is required</div>
                                <div *ngIf="f.email.errors.email">Email must be a valid email address</div>
                              </div>
                            </div>
                            <button type="submit" [disabled]="forgetPasswordForm.invalid" class="btn btn-primary">Send OTP</button>
                          </form>
                        </div>
                      </div>
                      </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>-->
<!--<div class="container">
  <h2>Forgot Password</h2>
  <form [formGroup]="forgetPasswordForm" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <label for="email">Email address</label>
      <input type="email" formControlName="email" class="form-control" id="email" placeholder="Enter email">
      <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
        <div *ngIf="f.email.errors.required">Email is required</div>
        <div *ngIf="f.email.errors.email">Email must be valid</div>
      </div>
    </div>
    <button type="submit" class="btn btn-primary" [disabled]="otpSent">Send OTP</button>
    <div *ngIf="errorMessage" class="alert alert-danger mt-2">{{ errorMessage }}</div>
  </form>
</div>-->
<!-- ═══════════════════════════════════════════════════════════════
     REGISTER — self-registration wizard (NEW feature).
     Three steps inside the shared auth shell:
       Step 1  Create account (name, email, mobile, password)
       Step 2  Verify OTP (email or mobile)
       Step 3  Select product(s) to access

     Bindings match register.component.ts (scaffold provided
     alongside). Adjust handler names to taste — they are new.
═══════════════════════════════════════════════════════════════ -->
<!--<div class="auth-shell">-->
<!--Branding panel-->
<!--<aside class="auth-brand">
  <div class="auth-brand-logo">
    <img src="assets/custom/images/abg/kg logo.jpeg" alt="KG Technologys" />
    <span>KG Technologys</span>
  </div>
  <h1 class="auth-brand-headline">Create your admin account in minutes.</h1>
  <p class="auth-brand-sub">
    Register with your email or mobile, verify with a one-time code, and pick the products your team needs.
  </p>
  <ul class="auth-brand-features">
    <li><i class="la la-check"></i> Self-service account creation</li>
    <li><i class="la la-shield"></i> OTP-verified for security</li>
    <li><i class="la la-th-large"></i> Choose from 5 powerful products</li>
    <li><i class="la la-clock-o"></i> Up and running in minutes</li>
  </ul>
  <div class="auth-brand-footer">© KG Technologys. All rights reserved.</div>
</aside>-->
<!--Form panel-->
<!--<main class="auth-main">
  <div class="auth-card">

    <div class="auth-mobile-logo">
      <img src="assets/custom/images/abg/kg logo.jpeg" alt="KG Technologys" />
    </div>-->
<!--Stepper-->
<!--<div class="auth-stepper">
  <div class="auth-step" [ngClass]="{ active: step === 1, done: step > 1 }">
    <span class="auth-step-dot"><i class="la la-user" *ngIf="step <= 1"></i><i class="la la-check" *ngIf="step > 1"></i></span>
    <span class="auth-step-label">Account</span>
  </div>
  <div class="auth-step-line" [ngClass]="{ done: step > 1 }"></div>
  <div class="auth-step" [ngClass]="{ active: step === 2, done: step > 2 }">
    <span class="auth-step-dot"><i class="la la-shield" *ngIf="step <= 2"></i><i class="la la-check" *ngIf="step > 2"></i></span>
    <span class="auth-step-label">Verify</span>
  </div>
  <div class="auth-step-line" [ngClass]="{ done: step > 2 }"></div>
  <div class="auth-step" [ngClass]="{ active: step === 3 }">
    <span class="auth-step-dot"><i class="la la-th-large"></i></span>
    <span class="auth-step-label">Products</span>
  </div>
</div>-->
<!--Feedback banner-->
<!--<div class="auth-banner auth-banner--error" *ngIf="errorMessage">
  <i class="la la-exclamation-circle"></i> <span>{{ errorMessage }}</span>
</div>
<div class="auth-banner auth-banner--success" *ngIf="successMessage">
  <i class="la la-check-circle"></i> <span>{{ successMessage }}</span>
</div>-->
<!--═══ STEP 1: ACCOUNT DETAILS ═══-->
<!--<form [formGroup]="registerForm" (ngSubmit)="submitAccount()" *ngIf="step === 1" novalidate>
  <h2 class="auth-title">Create account</h2>
  <p class="auth-sub">Tell us a few details to get started.</p>

  <div class="auth-field">
    <label class="auth-label">Full name</label>
    <div class="auth-input-wrap">
      <input type="text" class="auth-input" formControlName="fullName" placeholder="Your full name"
             [ngClass]="{ 'is-invalid': accSubmitted && rf.fullName.errors }" />
      <i class="auth-input-icon la la-user"></i>
    </div>
    <div class="auth-error" *ngIf="accSubmitted && rf.fullName.errors?.required">Full name is required</div>
  </div>

  <div class="auth-field">
    <label class="auth-label">Email address</label>
    <div class="auth-input-wrap">
      <input type="email" class="auth-input" formControlName="email" placeholder="you@example.com"
             [ngClass]="{ 'is-invalid': accSubmitted && rf.email.errors }" />
      <i class="auth-input-icon la la-envelope"></i>
    </div>
    <div class="auth-error" *ngIf="accSubmitted && rf.email.errors?.required">Email is required</div>
    <div class="auth-error" *ngIf="accSubmitted && rf.email.errors?.email">Enter a valid email</div>
  </div>

  <div class="auth-field">
    <label class="auth-label">Mobile number</label>
    <div class="auth-input-wrap">
      <input type="text" class="auth-input" formControlName="mobile" placeholder="10-digit mobile" maxlength="10"
             [ngClass]="{ 'is-invalid': accSubmitted && rf.mobile.errors }" />
      <i class="auth-input-icon la la-mobile"></i>
    </div>
    <div class="auth-error" *ngIf="accSubmitted && rf.mobile.errors?.required">Mobile is required</div>
    <div class="auth-error" *ngIf="accSubmitted && (rf.mobile.errors?.minlength || rf.mobile.errors?.pattern)">Enter a valid 10-digit number</div>
  </div>

  <div class="auth-field">
    <label class="auth-label">Password</label>
    <div class="auth-input-wrap">
      <input [type]="showPassword ? 'text' : 'password'" class="auth-input auth-input--with-trail"
             formControlName="password" placeholder="Create a password"
             (input)="onPasswordChange()"
             [ngClass]="{ 'is-invalid': accSubmitted && rf.password.errors }" />
      <i class="auth-input-icon la la-lock"></i>
      <button type="button" class="auth-input-trail" (click)="showPassword = !showPassword">
        <i class="la" [ngClass]="showPassword ? 'la-eye-slash' : 'la-eye'"></i>
      </button>
    </div>
    <div class="auth-strength" *ngIf="rf.password.value">
      <span class="auth-strength-bar" [ngClass]="passwordStrength >= 1 ? strengthClass : ''"></span>
      <span class="auth-strength-bar" [ngClass]="passwordStrength >= 2 ? strengthClass : ''"></span>
      <span class="auth-strength-bar" [ngClass]="passwordStrength >= 3 ? strengthClass : ''"></span>
    </div>
    <div class="auth-error" *ngIf="accSubmitted && rf.password.errors?.required">Password is required</div>
    <div class="auth-error" *ngIf="accSubmitted && rf.password.errors?.minlength">At least 8 characters</div>
  </div>

  <div class="auth-field">
    <label class="auth-label">Send code via</label>
    <div class="auth-btn-row">
      <button type="button" class="auth-btn"
              [ngClass]="otpChannel === 'email' ? 'auth-btn-primary' : 'auth-btn-secondary'"
              (click)="otpChannel = 'email'">
        <i class="la la-envelope"></i> Email
      </button>
      <button type="button" class="auth-btn"
              [ngClass]="otpChannel === 'mobile' ? 'auth-btn-primary' : 'auth-btn-secondary'"
              (click)="otpChannel = 'mobile'">
        <i class="la la-mobile"></i> Mobile
      </button>
    </div>
  </div>

  <button type="submit" class="auth-btn auth-btn-primary" [disabled]="loading">
    <i class="fa fa-refresh fa-spin" *ngIf="loading"></i>
    <span>{{ loading ? 'Sending code…' : 'Continue' }}</span>
  </button>

  <p class="auth-foot">
    Already have an account?
    <a [routerLink]="['/login']" class="auth-link">Sign in</a>
  </p>
</form>-->
<!--═══ STEP 2: OTP VERIFICATION ═══-->
<!--<div *ngIf="step === 2">
  <h2 class="auth-title">Verify it's you</h2>
  <p class="auth-sub">
    We sent a 6-digit code to your {{ otpChannel === 'email' ? 'email' : 'mobile' }}
    <strong>{{ otpChannel === 'email' ? registerForm.value.email : registerForm.value.mobile }}</strong>.
  </p>

  <div class="auth-otp-group">
    <input *ngFor="let box of otpBoxes; let i = index"
           #otpInput
           type="tel"
           inputmode="numeric"
           maxlength="1"
           class="auth-otp-input"
           [ngClass]="{ filled: otpDigits[i] }"
           [value]="otpDigits[i] || ''"
           (input)="onOtpInput($event, i)"
           (keydown)="onOtpKeydown($event, i)"
           (paste)="onOtpPaste($event)" />
  </div>

  <div class="auth-resend">
    Didn't get it?
    <button type="button" class="auth-link" [disabled]="resendCountdown > 0" (click)="resendOtp()">
      Resend code <span *ngIf="resendCountdown > 0">({{ resendCountdown }}s)</span>
    </button>
  </div>

  <button type="button" class="auth-btn auth-btn-primary" [disabled]="loading || !isOtpComplete()" (click)="verifyOtp()">
    <i class="fa fa-refresh fa-spin" *ngIf="loading"></i>
    <span>{{ loading ? 'Verifying…' : 'Verify' }}</span>
  </button>

  <p class="auth-foot">
    <a class="auth-link" (click)="step = 1">&larr; Change details</a>
  </p>
</div>-->
<!--═══ STEP 3: PRODUCT SELECTION ═══-->
<!--<div *ngIf="step === 3">
        <h2 class="auth-title">Choose your products</h2>
        <p class="auth-sub">Select the applications you'd like to access. You can change this later.</p>

        <div class="auth-product-grid">
          <button type="button" class="auth-product-card"
                  *ngFor="let p of products"
                  [ngClass]="{ selected: isProductSelected(p.id) }"
                  (click)="toggleProduct(p.id)">
            <span class="auth-product-icon" [ngClass]="p.cssClass"><i class="la" [ngClass]="p.icon"></i></span>
            <span class="auth-product-name">{{ p.name }}</span>
            <span class="auth-product-check"><i class="la la-check"></i></span>
          </button>
        </div>

        <button type="button" class="auth-btn auth-btn-primary" [disabled]="loading || selectedProducts.length === 0" (click)="finishRegistration()">
          <i class="fa fa-refresh fa-spin" *ngIf="loading"></i>
          <span>{{ loading ? 'Creating account…' : 'Finish & create account' }}</span>
        </button>

        <p class="auth-foot" *ngIf="selectedProducts.length === 0">Select at least one product to continue.</p>
      </div>

    </div>
  </main>
</div>-->
<!--<div class="auth-shell">
  <aside class="auth-brand">
    <div class="auth-brand-logo">
      <img src="assets/custom/images/abg/kg logo.jpeg" alt="KG Technologys" />
      <span>KG Technologys</span>
    </div>
    <h1 class="auth-brand-headline">Create your admin account in minutes.</h1>
    <p class="auth-brand-sub">
      Register with your email, choose a product, and verify with a one-time code.
    </p>
    <ul class="auth-brand-features">
      <li><i class="la la-check"></i> Self-service account creation</li>
      <li><i class="la la-shield"></i> OTP-verified for security</li>
      <li><i class="la la-th-large"></i> Choose your product access</li>
      <li><i class="la la-clock-o"></i> Up and running in minutes</li>
    </ul>
    <div class="auth-brand-footer">&copy; KG Technologys. All rights reserved.</div>
  </aside>

  <main class="auth-main">
    <div class="auth-card">
      <div class="auth-mobile-logo">
        <img src="assets/custom/images/abg/kg logo.jpeg" alt="KG Technologys" />
      </div>

      <div class="auth-stepper">
        <div class="auth-step" [ngClass]="{ active: step === 1, done: step > 1 }">
          <span class="auth-step-dot">
            <i class="la la-user" *ngIf="step <= 1"></i>
            <i class="la la-check" *ngIf="step > 1"></i>
          </span>
          <span class="auth-step-label">Account</span>
        </div>
        <div class="auth-step-line" [ngClass]="{ done: step > 1 }"></div>
        <div class="auth-step" [ngClass]="{ active: step === 2, done: step > 2 }">
          <span class="auth-step-dot">
            <i class="la la-th-large" *ngIf="step <= 2"></i>
            <i class="la la-check" *ngIf="step > 2"></i>
          </span>
          <span class="auth-step-label">Products</span>
        </div>
        <div class="auth-step-line" [ngClass]="{ done: step > 2 }"></div>
        <div class="auth-step" [ngClass]="{ active: step === 3 }">
          <span class="auth-step-dot"><i class="la la-shield"></i></span>
          <span class="auth-step-label">Verify</span>
        </div>
      </div>

      <div class="auth-banner auth-banner--error" *ngIf="errorMessage">
        <i class="la la-exclamation-circle"></i> <span>{{ errorMessage }}</span>
      </div>
      <div class="auth-banner auth-banner--success" *ngIf="successMessage">
        <i class="la la-check-circle"></i> <span>{{ successMessage }}</span>
      </div>

      <form [formGroup]="registerForm" (ngSubmit)="submitAccount()" *ngIf="step === 1" novalidate>
        <h2 class="auth-title">Create account</h2>
        <p class="auth-sub">Tell us a few details to get started.</p>

        <div class="auth-field">
          <label class="auth-label">Full name</label>
          <div class="auth-input-wrap">
            <input type="text" class="auth-input" formControlName="fullName" placeholder="Your full name"
                   [ngClass]="{ 'is-invalid': accSubmitted && rf.fullName.errors }" />
            <i class="auth-input-icon la la-user"></i>
          </div>
          <div class="auth-error" *ngIf="accSubmitted && rf.fullName.errors?.required">Full name is required</div>
        </div>

        <div class="auth-field">
          <label class="auth-label">Email address</label>
          <div class="auth-input-wrap">
            <input type="email" class="auth-input" formControlName="email" placeholder="you@example.com"
                   [ngClass]="{ 'is-invalid': accSubmitted && rf.email.errors }" />
            <i class="auth-input-icon la la-envelope"></i>
          </div>
          <div class="auth-error" *ngIf="accSubmitted && rf.email.errors?.required">Email is required</div>
          <div class="auth-error" *ngIf="accSubmitted && rf.email.errors?.email">Enter a valid email</div>
        </div>

        <div class="auth-field">
          <label class="auth-label">Mobile number</label>
          <div class="auth-input-wrap">
            <input type="text" class="auth-input" formControlName="mobile" placeholder="10-digit mobile" maxlength="10"
                   [ngClass]="{ 'is-invalid': accSubmitted && rf.mobile.errors }" />
            <i class="auth-input-icon la la-mobile"></i>
          </div>
          <div class="auth-error" *ngIf="accSubmitted && rf.mobile.errors?.required">Mobile is required</div>
          <div class="auth-error" *ngIf="accSubmitted && (rf.mobile.errors?.minlength || rf.mobile.errors?.pattern)">Enter a valid 10-digit number</div>
        </div>

        <div class="auth-field">
          <label class="auth-label">Password</label>
          <div class="auth-input-wrap">
            <input [type]="showPassword ? 'text' : 'password'" class="auth-input auth-input--with-trail"
                   formControlName="password" placeholder="Create a password"
                   (input)="onPasswordChange()"
                   [ngClass]="{ 'is-invalid': accSubmitted && rf.password.errors }" />
            <i class="auth-input-icon la la-lock"></i>
            <button type="button" class="auth-input-trail" (click)="showPassword = !showPassword">
              <i class="la" [ngClass]="showPassword ? 'la-eye-slash' : 'la-eye'"></i>
            </button>
          </div>
          <div class="auth-strength" *ngIf="rf.password.value">
            <span class="auth-strength-bar" [ngClass]="passwordStrength >= 1 ? strengthClass : ''"></span>
            <span class="auth-strength-bar" [ngClass]="passwordStrength >= 2 ? strengthClass : ''"></span>
            <span class="auth-strength-bar" [ngClass]="passwordStrength >= 3 ? strengthClass : ''"></span>
          </div>
          <div class="auth-error" *ngIf="accSubmitted && rf.password.errors?.required">Password is required</div>
          <div class="auth-error" *ngIf="accSubmitted && rf.password.errors?.minlength">At least 8 characters</div>
        </div>

        <label class="auth-terms">
          <input type="checkbox" formControlName="acceptTerms" />
          <span>I accept the Terms &amp; Conditions</span>
        </label>
        <div class="auth-error" *ngIf="accSubmitted && rf.acceptTerms.errors?.required">
          Please accept the Terms &amp; Conditions.
        </div>

        <button type="submit" class="auth-btn auth-btn-primary" [disabled]="loading">
          <span>Continue</span>
        </button>

        <p class="auth-foot">
          Already have an account?
          <a [routerLink]="['/login']" class="auth-link">Sign in</a>
        </p>
      </form>

      <div *ngIf="step === 2">
        <h2 class="auth-title">Choose your product</h2>
        <p class="auth-sub">Select the application you want to start with.</p>

        <div class="auth-product-grid">
          <button type="button" class="auth-product-card"
                  *ngFor="let p of products"
                  [ngClass]="{ selected: isProductSelected(p.id) }"
                  (click)="toggleProduct(p.id)">
            <span class="auth-product-icon" [ngClass]="p.cssClass"><i class="la" [ngClass]="p.icon"></i></span>
            <span class="auth-product-name">{{ p.name }}</span>
            <span class="auth-product-check"><i class="la la-check"></i></span>
          </button>
        </div>

        <button type="button" class="auth-btn auth-btn-primary" [disabled]="loading || selectedProducts.length === 0" (click)="finishRegistration()">
          <i class="fa fa-refresh fa-spin" *ngIf="loading"></i>
          <span>{{ loading ? 'Sending code...' : 'Send verification code' }}</span>
        </button>

        <p class="auth-foot">
          <a class="auth-link" (click)="step = 1">&larr; Change details</a>
        </p>
      </div>

      <div *ngIf="step === 3">
        <h2 class="auth-title">Verify your email</h2>
        <p class="auth-sub">
          We sent a 6-digit code to <strong>{{ registerForm.value.email }}</strong>.
        </p>

        <div class="auth-otp-group">
          <input *ngFor="let box of otpBoxes; let i = index"
                 #otpInput
                 type="tel"
                 inputmode="numeric"
                 maxlength="1"
                 class="auth-otp-input"
                 [ngClass]="{ filled: otpDigits[i] }"
                 [value]="otpDigits[i] || ''"
                 (input)="onOtpInput($event, i)"
                 (keydown)="onOtpKeydown($event, i)"
                 (paste)="onOtpPaste($event)" />
        </div>

        <div class="auth-resend">
          Didn't get it?
          <button type="button" class="auth-link" [disabled]="resendCountdown > 0" (click)="resendOtp()">
            Resend code <span *ngIf="resendCountdown > 0">({{ resendCountdown }}s)</span>
          </button>
        </div>

        <button type="button" class="auth-btn auth-btn-primary" [disabled]="loading || !isOtpComplete()" (click)="verifyOtp()">
          <i class="fa fa-refresh fa-spin" *ngIf="loading"></i>
          <span>{{ loading ? 'Verifying...' : 'Verify' }}</span>
        </button>

        <p class="auth-foot">
          <a class="auth-link" (click)="step = 2">&larr; Change product</a>
        </p>
      </div>
    </div>
  </main>
</div>-->
<!--<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-header row mb-1">
      <app-breadcrumb class="col-12" [breadcrumb]="breadcrumb"></app-breadcrumb>
    </div>

    <div class="content-body">
      <section class="registration-module" id="registration-module">
        <div class="card reg-card">-->
<!-- ══════════════════ Header: tabs + toolbar ══════════════════ -->
<!--<div class="reg-header">
  <div class="reg-tabs" role="tablist">
    <button type="button" role="tab" class="reg-tab" [class.active]="activeTab === 'client'"
            [attr.aria-selected]="activeTab === 'client'" (click)="setTab('client')">
      <i class="la la-building"></i> Clients
      <span class="reg-count" *ngIf="ClientData">{{ClientData.length}}</span>
    </button>
    <button type="button" role="tab" class="reg-tab" [class.active]="activeTab === 'account'"
            [attr.aria-selected]="activeTab === 'account'" (click)="setTab('account')">
      <i class="la la-user-secret"></i> Accounts
      <span class="reg-count" *ngIf="AccountData">{{AccountData.length}}</span>
    </button>
  </div>-->
<!-- Client toolbar -->
<!--<div class="reg-toolbar" *ngIf="activeTab === 'client'">
  <div class="reg-search">
    <i class="icon-magnifier"></i>
    <input type="text" class="form-control" placeholder="Search clients by company name"
           (keyup)="updateClientFilter($event)">
  </div>
  <button type="button" class="btn reg-btn-primary" data-backdrop="false"
          (click)="ViewClientPopup(ClientContent,'Add',null)">
    <i class="la la-plus"></i> Add Client
  </button>
</div>-->
<!-- Account toolbar -->
<!--<div class="reg-toolbar" *ngIf="activeTab === 'account'">
    <div class="reg-search">
      <i class="icon-magnifier"></i>
      <input type="text" class="form-control" placeholder="Search accounts by name"
             (keyup)="updateAccountFilter($event)">
    </div>
    <button type="button" class="btn reg-btn-primary" data-backdrop="false"
            (click)="ViewAccountPopup(AccountContent,'Add',null)">
      <i class="la la-plus"></i> Add Account
    </button>
  </div>
</div>-->
<!-- ══════════════════ Clients grid ══════════════════ -->
<!--<div class="reg-table-wrap" [hidden]="activeTab !== 'client'">
  <ngx-datatable #clientTable class="bootstrap ps reg-table" [limit]="6" [rows]="ClientData"
                 [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50" [rowHeight]="44" fxFlex="auto">
    <ngx-datatable-column name="Action" width="110" [sortable]="false">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <div class="reg-actions">
          <a class="reg-action-btn la la-edit" triggers="hover:click:hover" *ngIf="writeAccess || fullcontrolAccess"
             placement="top" ngbPopover="Edit" (click)="ViewClientPopup(ClientContent,'Edit',row)"></a>
          <a class="reg-action-btn la la-eye" triggers="hover:click:hover" *ngIf="readAccess || fullcontrolAccess"
             placement="top" ngbPopover="View" (click)="ViewClientPopup(ClientContent,'View',row)"></a>
          <a class="reg-action-btn danger la la-trash" triggers="hover:click:hover" *ngIf="deleteAccess || fullcontrolAccess"
             placement="top" ngbPopover="Delete" (click)="ViewClientPopup(DeleteConfirmation,'Delete',row)"></a>
          <a class="reg-action-btn accent feather ft-navigation" *ngIf="validateAccountRegistration(row.clientRegistrationUId)"
             triggers="hover:click:hover" placement="top" ngbPopover="Create Account"
             (click)="TransfertoAccountRegistration(row.clientRegistrationUId)"></a>
        </div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Company Name">
      <ng-template let-row="row" ngx-datatable-cell-template>{{row.companyName}}</ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Name">
      <ng-template let-row="row" ngx-datatable-cell-template>{{row.fullName}}</ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Product Name">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <span class="reg-badge">{{row.product.productName}}</span>
      </ng-template>
    </ngx-datatable-column>
  </ngx-datatable>
</div>-->
<!-- ══════════════════ Accounts grid ══════════════════ -->
<!--<div class="reg-table-wrap" [hidden]="activeTab !== 'account'">
            <ngx-datatable #accountTable class="bootstrap ps reg-table" [limit]="6" [rows]="AccountData"
                           [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50" [rowHeight]="44" fxFlex="auto">
              <ngx-datatable-column name="Action" width="90" [sortable]="false">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <div class="reg-actions">
                    <a class="reg-action-btn la la-edit" triggers="hover:click:hover" *ngIf="writeAccess || fullcontrolAccess"
                       placement="top" ngbPopover="Edit" (click)="ViewAccountPopup(AccountContent,'Edit',row)"></a>
                    <a class="reg-action-btn la la-eye" triggers="hover:click:hover" *ngIf="readAccess || fullcontrolAccess"
                       placement="top" ngbPopover="View" (click)="ViewAccountPopup(AccountContent,'View',row)"></a>
                    <a class="reg-action-btn danger la la-trash" triggers="hover:click:hover" *ngIf="deleteAccess || fullcontrolAccess"
                       placement="top" ngbPopover="Delete" (click)="ViewAccountPopup(DeleteConfirmation,'Delete',row)"></a>
                  </div>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Name">
                <ng-template let-row="row" ngx-datatable-cell-template>{{row.name}}</ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Product Name">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <span class="reg-badge">{{row.product.productName}}</span>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Client Name">
                <ng-template let-row="row" ngx-datatable-cell-template>{{row.clientRegistration.companyName}}</ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="EmailID">
                <ng-template let-row="row" ngx-datatable-cell-template>{{row.email}}</ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="MobileNumber">
                <ng-template let-row="row" ngx-datatable-cell-template>{{row.mobileNumber}}</ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
          </div>

        </div>
      </section>
    </div>
  </div>
</div>-->
<!-- ════════════════════════════════════════════════════════════════════════════
     CLIENT MODAL
     ════════════════════════════════════════════════════════════════════════════ -->
<!--<ng-template class="modal text-left" #ClientContent let-c="close" let-d="dismiss">
  <form name="clientForm" #clientForm="ngForm" (ngSubmit)="SaveClient(clientForm)" novalidate>
    <div class="modal-header reg-modal-header">
      <h4 class="modal-title">{{action}} Client</h4>
      <button type="button" class="close" aria-label="Close" (click)="closePopup(clientForm,ChangesConfirmation)">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body reg-modal-body">
      <div class="form-body">-->
<!-- ── Section: Company & product ── -->
<!--<div class="reg-section">
  <h5 class="reg-section-title"><span class="reg-section-icon la la-briefcase"></span> Company &amp; Product</h5>
  <div class="row">
    <div class="col-md-4">
      <div class="form-group">
        <label>Company Name </label> <label *ngIf="action != 'View'" class="danger">*</label>
        <input type="text" class="form-control" required name="companyName" #companyName="ngModel"
               [ngClass]="{ 'is-invalid': clientForm.submitted && companyName.errors }" maxlength="30"
               whiteSpaceValidator placeholder="Enter Company Name" [disabled]="action == 'View'"
               [(ngModel)]="client.companyName" />
        <div *ngIf="clientForm.submitted && companyName.errors" class="invalid-feedback">
          <div *ngIf="companyName.errors['required']"></div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-group">
        <label>Logo</label><label *ngIf="action != 'View'" class="danger">*</label>
        <div class="custom-file">
          <input type="file" class="custom-file-input" id="clientLogoFile" accept="image/*" required
                 (change)="onFileChange($event.target.files)">
          <label class="custom-file-label" for="clientLogoFile">{{logoChoosefile}}</label>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-group">
        <label>Product Name</label><label *ngIf="action != 'View'" class="danger">*</label>
        <select name="productName" (change)="GetProductUId($event)" class="form-control"
                [disabled]="action == 'View'" [(ngModel)]="client.productUId" #productName="ngModel" required
                [ngClass]="{ 'is-invalid': clientForm.submitted && productName.errors }">
          <option [value]="pro.productUId" *ngFor="let pro of ProductDetailsList">{{pro.productName}}</option>
        </select>
      </div>
    </div>
  </div>
</div>-->
<!-- ── Section: Personal information ── -->
<!--<div class="reg-section">
  <h5 class="reg-section-title"><span class="reg-section-icon la la-user"></span> Personal Information</h5>
  <div class="row">
    <div class="col-md-4">
      <div class="form-group">
        <label>Full Name </label> <label *ngIf="action != 'View'" class="danger">*</label>
        <input type="text" class="form-control" required name="fullName" maxlength="20" #fullName="ngModel"
               [ngClass]="{ 'is-invalid': clientForm.submitted && fullName.errors }" whiteSpaceValidator
               placeholder="Enter Name" [disabled]="action == 'View'" [(ngModel)]="client.fullName" />
        <div *ngIf="clientForm.submitted && fullName.errors" class="invalid-feedback">
          <div *ngIf="fullName.errors['required']"></div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-group">
        <label>Date Of Birth</label> <label *ngIf="action != 'View'" class="danger">*</label>
        <div class="input-group">
          <input class="form-control" name="dateofBirth" required [disabled]="action == 'View'"
                 [max]="getToday()" [(ngModel)]="client.dateofBirth" #dateofBirth="ngModel"
                 [ngClass]="{ 'is-invalid': clientForm.submitted && dateofBirth.errors }"
                 data-date-format="DD MMMM YYYY" type="date">
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-group">
        <label>Gender</label><label *ngIf="action != 'View'" class="danger">*</label>
        <div class="reg-radio-row">
          <div class="d-inline-block custom-control custom-radio mr-1">
            <input type="radio" class="custom-control-input" name="gender" id="genderMale"
                   [(ngModel)]="client.gender" value="Male" #genderMale="ngModel" required
                   [ngClass]="{ 'is-invalid': clientForm.submitted && genderMale.errors }">
            <label class="custom-control-label" for="genderMale">Male</label>
          </div>
          <div class="d-inline-block custom-control custom-radio mr-1">
            <input type="radio" class="custom-control-input" name="gender" id="genderFemale"
                   [(ngModel)]="client.gender" value="Female" #genderFemale="ngModel" required
                   [ngClass]="{ 'is-invalid': clientForm.submitted && genderFemale.errors }">
            <label class="custom-control-label" for="genderFemale">Female</label>
          </div>
          <div class="d-inline-block custom-control custom-radio mr-1">
            <input type="radio" class="custom-control-input" name="gender" id="genderOthers"
                   [(ngModel)]="client.gender" value="others" #genderOthers="ngModel" required
                   [ngClass]="{ 'is-invalid': clientForm.submitted && genderOthers.errors }">
            <label class="custom-control-label" for="genderOthers">Others</label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-4">
      <div class="form-group">
        <label>Company Certificate Number </label><label *ngIf="action != 'View'" class="danger">*</label>
        <input type="text" class="form-control" required name="companyCertificateNumber"
               #companyCertificateNumber="ngModel"
               [ngClass]="{ 'is-invalid': clientForm.submitted && companyCertificateNumber.errors }"
               maxlength="15" minlength="15" whiteSpaceValidator pattern="[A-Za-z0-9]+"
               placeholder="Enter CC.No(Ex:98THUBD89RFG906)" [disabled]="action == 'View'"
               [(ngModel)]="client.companyCertificateNumber" />
        <div *ngIf="clientForm.submitted && companyCertificateNumber.errors" class="invalid-feedback">
          <div *ngIf="companyCertificateNumber.errors['required']"></div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-group">
        <label>Aadhar Number </label><label *ngIf="action != 'View'" class="danger">*</label>
        <input type="text" class="form-control" required name="aadharNumber" #aadharNumber="ngModel"
               [ngClass]="{ 'is-invalid': clientForm.submitted && aadharNumber.errors }" maxlength="12"
               minlength="12" whiteSpaceValidator numberValidator placeholder="Enter Aadhar No."
               [disabled]="action == 'View'" [(ngModel)]="client.aadharNumber" />
        <div *ngIf="clientForm.submitted && aadharNumber.errors" class="invalid-feedback">
          <div *ngIf="aadharNumber.errors['required']"></div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-group">
        <label>PAN Number </label> <label *ngIf="action != 'View'" class="danger">*</label>
        <input type="text" class="form-control" required name="panNumber" #panNumber="ngModel" minlength="10"
               pattern="[A-Za-z0-9]+" [ngClass]="{ 'is-invalid': clientForm.submitted && panNumber.errors }"
               placeholder="Enter PAN No" maxlength="10" whiteSpaceValidator [disabled]="action == 'View'"
               [(ngModel)]="client.panNumber" />
        <div *ngIf="clientForm.submitted && panNumber.errors" class="invalid-feedback">
          <div *ngIf="panNumber.errors['required']"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-4">
      <div class="form-group">
        <label>GST Number </label> <label *ngIf="action != 'View'" class="danger">*</label>
        <input type="text" class="form-control" required name="gstNumber" #gstNumber="ngModel" minlength="15"
               pattern="[A-Za-z0-9]+" [ngClass]="{ 'is-invalid': clientForm.submitted && gstNumber.errors }"
               placeholder="Enter GST No(Ex:33YN6754VGH897D)" whiteSpaceValidator maxlength="15"
               [disabled]="action == 'View'" [(ngModel)]="client.gstNumber" />
        <div *ngIf="clientForm.submitted && gstNumber.errors" class="invalid-feedback">
          <div *ngIf="gstNumber.errors['required']"></div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-group">
        <label>Email Address </label> <label *ngIf="action != 'View'" class="danger">*</label>
        <input type="text" class="form-control" required name="emailAddress" #emailAddress="ngModel"
               [ngClass]="{ 'is-invalid': clientForm.submitted && emailAddress.errors }"
               pattern="^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$"
               placeholder="Enter EmailID" maxlength="35" whiteSpaceValidator email
               [disabled]="action == 'View'" [(ngModel)]="client.emailAddress" />
        <div *ngIf="clientForm.submitted && emailAddress.errors" class="invalid-feedback">
          <div *ngIf="emailAddress.errors['required']"></div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-group">
        <label>Phone Number(Home) </label>
        <input type="text" class="form-control" placeholder="Enter Home PhoneNo(Optional)" minlength="10"
               name="phoneNumberHome" maxlength="10" whiteSpaceValidator numberValidator
               #phoneNumberHome="ngModel"
               [ngClass]="{ 'is-invalid': clientForm.submitted && phoneNumberHome.errors }"
               [disabled]="action == 'View'" [(ngModel)]="client.phoneNumberHome" />
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-4">
      <div class="form-group">
        <label>Mobile Number1 </label> <label *ngIf="action != 'View'" class="danger">*</label>
        <input type="text" class="form-control" required name="mobileNumber1" minlength="10"
               placeholder="Enter Mobile No." #mobileNumber1="ngModel"
               [ngClass]="{ 'is-invalid': clientForm.submitted && mobileNumber1.errors }" maxlength="10"
               whiteSpaceValidator numberValidator [disabled]="action == 'View'"
               [(ngModel)]="client.mobileNumber1" />
        <div *ngIf="clientForm.submitted && mobileNumber1.errors" class="invalid-feedback">
          <div *ngIf="mobileNumber1.errors['required']"></div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-group">
        <label>Mobile Number2 </label>
        <input type="text" class="form-control" name="mobileNumber2" minlength="10"
               placeholder="Mobile No2(Optional)" maxlength="10" whiteSpaceValidator #mobileNumber2="ngModel"
               [ngClass]="{ 'is-invalid': clientForm.submitted && mobileNumber2.errors }" numberValidator
               [disabled]="action == 'View'" [(ngModel)]="client.mobileNumber2" />
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-group">
        <label>Country </label> <label *ngIf="action != 'View'" class="danger">*</label>
        <input type="text" class="form-control" required name="country" placeholder="Enter Country"
               pattern="^[a-zA-Z_ ]*$" #country="ngModel"
               [ngClass]="{ 'is-invalid': clientForm.submitted && country.errors }" maxlength="20"
               whiteSpaceValidator [disabled]="action == 'View'" [(ngModel)]="client.country" />
        <div *ngIf="clientForm.submitted && country.errors" class="invalid-feedback">
          <div *ngIf="country.errors['required']"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-4">
      <div class="form-group">
        <label>City </label> <label *ngIf="action != 'View'" class="danger">*</label>
        <input type="text" class="form-control" required name="city" #city="ngModel" placeholder="Enter City"
               pattern="^[a-zA-Z_ ]*$" [ngClass]="{ 'is-invalid': clientForm.submitted && city.errors }"
               maxlength="20" whiteSpaceValidator [disabled]="action == 'View'" [(ngModel)]="client.city" />
        <div *ngIf="clientForm.submitted && city.errors" class="invalid-feedback">
          <div *ngIf="city.errors['required']"></div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-group">
        <label>Zip Code </label> <label *ngIf="action != 'View'" class="danger">*</label>
        <input type="text" class="form-control" required name="zipCode" #zipCode="ngModel"
               [ngClass]="{ 'is-invalid': clientForm.submitted && zipCode.errors }" maxlength="6" minlength="6"
               whiteSpaceValidator numberValidator placeholder="Enter Zipcode" [disabled]="action == 'View'"
               [(ngModel)]="client.zipCode" />
        <div *ngIf="clientForm.submitted && zipCode.errors" class="invalid-feedback">
          <div *ngIf="zipCode.errors['required']"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div class="form-group">
        <label>Address </label> <label *ngIf="action != 'View'" class="danger">*</label>
        <textarea class="form-control" #address="ngModel" placeholder="Enter Address"
                  [ngClass]="{ 'is-invalid': clientForm.submitted && address.errors }" whiteSpaceValidator
                  rows="3" required name="address" [disabled]="action == 'View'"
                  [(ngModel)]="client.address"></textarea>
        <div *ngIf="clientForm.submitted && address.errors" class="invalid-feedback">
          <div *ngIf="address.errors['required']"></div>
        </div>
      </div>
    </div>
  </div>
</div>-->
<!-- ── Section: Company information ── -->
<!--<div class="reg-section">
  <h5 class="reg-section-title"><span class="reg-section-icon la la-building-o"></span> Company Information <small>(if applicable)</small></h5>
  <div class="row">
    <div class="col-md-4">
      <div class="form-group">
        <label>Industry </label> <label *ngIf="action != 'View'" class="danger">*</label>
        <input type="text" class="form-control" required name="industry" #industry="ngModel"
               placeholder="Enter Industry"
               [ngClass]="{ 'is-invalid': clientForm.submitted && industry.errors }" maxlength="25"
               whiteSpaceValidator [disabled]="action == 'View'" [(ngModel)]="client.industry" />
        <div *ngIf="clientForm.submitted && industry.errors" class="invalid-feedback">
          <div *ngIf="industry.errors['required']"></div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-group">
        <label>Job Title/Position </label> <label *ngIf="action != 'View'" class="danger">*</label>
        <input type="text" class="form-control" placeholder="Enter JobTitle or Position"
               #jobTitleOrPosition="ngModel"
               [ngClass]="{ 'is-invalid': clientForm.submitted && jobTitleOrPosition.errors }" maxlength="20"
               whiteSpaceValidator required name="jobTitleOrPosition" [disabled]="action == 'View'"
               [(ngModel)]="client.jobTitleOrPosition" />
        <div *ngIf="clientForm.submitted && jobTitleOrPosition.errors" class="invalid-feedback">
          <div *ngIf="jobTitleOrPosition.errors['required']"></div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-group">
        <label>Website </label>
        <input type="text" class="form-control" placeholder="Enter Website" #website="ngModel"
               pattern="^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$"
               [ngClass]="{ 'is-invalid': clientForm.submitted && website.errors }" name="website"
               maxlength="35" whiteSpaceValidator [disabled]="action == 'View'" [(ngModel)]="client.website" />
        <div *ngIf="clientForm.submitted && website.errors" class="invalid-feedback">
          <div *ngIf="website.errors['required']"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-4">
      <div class="form-group">
        <label>E-mail id </label> <label *ngIf="action != 'View'" class="danger">*</label>
        <input type="text" class="form-control" placeholder="Enter Company EmailID"
               #companyEmailAddress="ngModel"
               [ngClass]="{ 'is-invalid': clientForm.submitted && companyEmailAddress.errors }"
               pattern="^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$"
               maxlength="35" whiteSpaceValidator email required name="companyEmailAddress"
               [disabled]="action == 'View'" [(ngModel)]="client.companyEmailAddress" />
        <div *ngIf="clientForm.submitted && companyEmailAddress.errors" class="invalid-feedback">
          <div *ngIf="companyEmailAddress.errors['required']"></div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-group">
        <label>Phone Number(Office) </label> <label *ngIf="action != 'View'" class="danger">*</label>
        <input type="text" class="form-control" #phoneNumberOffice="ngModel"
               placeholder="Enter Office PhoneNumber"
               [ngClass]="{ 'is-invalid': clientForm.submitted && phoneNumberOffice.errors }" required
               name="phoneNumberOffice" maxlength="10" minlength="10" whiteSpaceValidator numberValidator
               [disabled]="action == 'View'" [(ngModel)]="client.phoneNumberOffice" />
        <div *ngIf="clientForm.submitted && phoneNumberOffice.errors" class="invalid-feedback">
          <div *ngIf="phoneNumberOffice.errors['required']"></div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-group">
        <label>Phone Number1 </label>
        <input type="text" class="form-control" name="phoneNumber1"
               placeholder="Enter PhoneNumber1(Optional)" #phoneNumber1="ngModel"
               [ngClass]="{ 'is-invalid': clientForm.submitted && phoneNumber1.errors }" minlength="10"
               maxlength="10" whiteSpaceValidator numberValidator [disabled]="action == 'View'"
               [(ngModel)]="client.phoneNumber1" />
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-4">
      <div class="form-group">
        <label>Phone Number2 </label>
        <input type="text" class="form-control" name="phoneNumber2"
               placeholder="Enter PhoneNumber2(Optional)" #phoneNumber2="ngModel"
               [ngClass]="{ 'is-invalid': clientForm.submitted && phoneNumber2.errors }" minlength="10"
               maxlength="10" whiteSpaceValidator numberValidator [disabled]="action == 'View'"
               [(ngModel)]="client.phoneNumber2" />
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-group">
        <label>Country </label> <label *ngIf="action != 'View'" class="danger">*</label>
        <input type="text" class="form-control" required name="companyCountry" placeholder="Enter Country"
               pattern="^[a-zA-Z_ ]*$" #companyCountry="ngModel"
               [ngClass]="{ 'is-invalid': clientForm.submitted && companyCountry.errors }" maxlength="20"
               whiteSpaceValidator [disabled]="action == 'View'" [(ngModel)]="client.companyCountry" />
        <div *ngIf="clientForm.submitted && companyCountry.errors" class="invalid-feedback">
          <div *ngIf="companyCountry.errors['required']"></div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-group">
        <label> City </label> <label *ngIf="action != 'View'" class="danger">*</label>
        <input type="text" class="form-control" placeholder="Enter City" #companyCity="ngModel"
               pattern="^[a-zA-Z_ ]*$"
               [ngClass]="{ 'is-invalid': clientForm.submitted && companyCity.errors }" required
               name="companyCity" maxlength="20" whiteSpaceValidator [disabled]="action == 'View'"
               [(ngModel)]="client.companyCity" />
        <div *ngIf="clientForm.submitted && companyCity.errors" class="invalid-feedback">
          <div *ngIf="companyCity.errors['required']"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div class="form-group">
        <label>Zip Code </label> <label *ngIf="action != 'View'" class="danger">*</label>
        <input type="text" class="form-control" required name="companyZipCode" placeholder="Enter Zipcode"
               #companyZipCode="ngModel"
               [ngClass]="{ 'is-invalid': clientForm.submitted && companyZipCode.errors }" minlength="6"
               maxlength="6" whiteSpaceValidator numberValidator [disabled]="action == 'View'"
               [(ngModel)]="client.companyZipCode" />
        <div *ngIf="clientForm.submitted && companyZipCode.errors" class="invalid-feedback">
          <div *ngIf="companyZipCode.errors['required']"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div class="form-group">
        <label>Company Address </label> <label *ngIf="action != 'View'" class="danger">*</label>
        <textarea class="form-control" whiteSpaceValidator rows="3" placeholder="Enter Company Address"
                  #companyAddress="ngModel"
                  [ngClass]="{ 'is-invalid': clientForm.submitted && companyAddress.errors }" required
                  name="companyAddress" [disabled]="action == 'View'"
                  [(ngModel)]="client.companyAddress"></textarea>
        <div *ngIf="clientForm.submitted && companyAddress.errors" class="invalid-feedback">
          <div *ngIf="companyAddress.errors['required']"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div class="form-group">
        <label>Communication address </label> <label *ngIf="action != 'View'" class="danger">*</label>
        <textarea class="form-control" rows="3" placeholder="Enter Communication Address" required
                  #communicationAddress="ngModel"
                  [ngClass]="{ 'is-invalid': clientForm.submitted && communicationAddress.errors }"
                  whiteSpaceValidator name="communicationAddress" [disabled]="action == 'View'"
                  [(ngModel)]="client.communicationAddress"></textarea>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div class="form-group">
        <label>Permanent address </label><label *ngIf="action != 'View'" class="danger">*</label>
        <ui-switch type="checkbox" class="switchery" name="samecommaddr"
                   title="Same as Communication Address"
                   [checked]="((action=='Edit'||action == 'View') && client.communicationAddress==client.permanentAddress)"
                   (change)="updateAddrs($event)" switchColor="white" size="small" color="rgb(55, 188, 155)">
        </ui-switch>
        <textarea class="form-control" rows="3" placeholder="Enter Permanent Address" required
                  #permanentAddress="ngModel"
                  [ngClass]="{ 'is-invalid': clientForm.submitted && permanentAddress.errors }"
                  whiteSpaceValidator name="permanentAddress" [disabled]="action == 'View'"
                  [(ngModel)]="client.permanentAddress"></textarea>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div class="form-group">
        <label>Please provide a brief description of the project or service your require assistance with:</label>
        <label *ngIf="action != 'View'" class="danger">*</label>
        <textarea class="form-control" rows="3" maxlength="50" placeholder="Enter Assistance Required"
                  #descriptionOfTheProjectOrServiceYouRequireAssistance="ngModel"
                  [ngClass]="{ 'is-invalid': clientForm.submitted && descriptionOfTheProjectOrServiceYouRequireAssistance.errors }"
                  whiteSpaceValidator required name="descriptionOfTheProjectOrServiceYouRequireAssistance"
                  [disabled]="action == 'View'"
                  [(ngModel)]="client.descriptionOfTheProjectOrServiceYouRequireAssistance"></textarea>
      </div>
    </div>
  </div>
</div>-->
<!-- ── Section: How did you hear about us? ── -->
<!--<div class="reg-section">
  <h5 class="reg-section-title"><span class="reg-section-icon la la-bullhorn"></span> How did you hear about us?</h5>
  <div class="reg-check-grid">
    <label class="reg-check">
      <input type="checkbox" name="onlineSearch"
             (change)="onlineSearch = $event.target.checked ? true: false" [(ngModel)]="client.onlineSearch">
      <span>Online Search</span>
    </label>
    <label class="reg-check">
      <input type="checkbox" name="referralFromFriendOrFamilyMember"
             (change)="referralFromFriendOrFamilyMember = $event.target.checked ? true: false"
             [(ngModel)]="client.referralFromFriendOrFamilyMember">
      <span>Referral from a friend/family member</span>
    </label>
    <label class="reg-check">
      <input type="checkbox" name="socialMedia"
             (change)="socialMedia = $event.target.checked ? true: false" [(ngModel)]="client.socialMedia">
      <span>Social media</span>
    </label>
    <label class="reg-check">
      <input type="checkbox" (change)="advertisement = $event.target.checked ? true: false"
             name="advertisement" [(ngModel)]="client.advertisement">
      <span>Advertisement(please specify source)</span>
    </label>
    <label class="reg-check">
      <input type="checkbox" (change)="other = $event.target.checked ? true: false" name="other"
             [(ngModel)]="client.other">
      <span>Other(please specify)</span>
    </label>
  </div>
</div>-->
<!-- ── Section: Preferred method of communication ── -->
<!--<div class="reg-section">
  <h5 class="reg-section-title"><span class="reg-section-icon la la-comments"></span> Preferred Method of Communication</h5>
  <div class="row">
    <div class="col-md-4">
      <div class="form-group">
        <label>Email</label> <label *ngIf="action != 'View'" class="danger">*</label>
        <input type="text" class="form-control" required name="email" placeholder="Enter EmailID"
               #email="ngModel" [ngClass]="{ 'is-invalid': clientForm.submitted && email.errors }"
               pattern="^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$"
               maxlength="35" whiteSpaceValidator email [disabled]="action == 'View'"
               [(ngModel)]="client.email" />
        <div *ngIf="clientForm.submitted && email.errors" class="invalid-feedback">
          <div *ngIf="email.errors['required']"></div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-group">
        <label>Phone</label> <label *ngIf="action != 'View'" class="danger">*</label>
        <input type="text" class="form-control" placeholder="Enter PhoneNumber" #phone="ngModel"
               [ngClass]="{ 'is-invalid': clientForm.submitted && phone.errors }" required name="phone"
               minlength="10" maxlength="10" whiteSpaceValidator numberValidator [disabled]="action == 'View'"
               [(ngModel)]="client.phone" />
        <div *ngIf="clientForm.submitted && phone.errors" class="invalid-feedback">
          <div *ngIf="phone.errors['required']"></div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-group">
        <label>In-person meetings </label> <label *ngIf="action != 'View'" class="danger">*</label>
        <input type="text" class="form-control" required name="inPersonMeetings"
               placeholder="Enter InPersonMeetings" #inPersonMeetings="ngModel"
               [ngClass]="{ 'is-invalid': clientForm.submitted && inPersonMeetings.errors }" maxlength="20"
               whiteSpaceValidator [disabled]="action == 'View'" [(ngModel)]="client.inPersonMeetings" />
        <div *ngIf="clientForm.submitted && inPersonMeetings.errors" class="invalid-feedback">
          <div *ngIf="inPersonMeetings.errors['required']"></div>
        </div>
      </div>
    </div>
  </div>
</div>-->
<!-- ── Section: Additional details & declarations ── -->
<!--<div class="reg-section">
          <h5 class="reg-section-title"><span class="reg-section-icon la la-check-square-o"></span> Additional Comments &amp; Declarations</h5>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Thank You Choosing Our Service,We will review your information and get in touch with you shortly</label>
                <textarea class="form-control" rows="3" maxlength="50"
                          placeholder="Enter the review your Information" whiteSpaceValidator
                          name="thankYouForChoosingOurServices"
                          [(ngModel)]="client.thankYouForChoosingOurServices"></textarea>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Redeem Point Value</label>
                <input type="text" class="form-control" maxlength="4" numberValidator whiteSpaceValidator
                       placeholder="Enter RedeemPointValue" name="redeemPointValue"
                       [(ngModel)]="client.redeemPointValue" />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4" *ngIf="ProductUID=='00000020-0000-0000-0000-000000000000'">
              <div class="form-group">
                <label>Membership Renewal Days Count</label>
                <input type="text" class="form-control" name="renewalDaysCount" placeholder="Enter RenewalDaysCount"
                       numberValidatior maxlength="1" #renewalDaysCount="ngModel"
                       [ngClass]="{ 'is-invalid': clientForm.submitted && renewalDaysCount.errors }"
                       whiteSpaceValidator [disabled]="action == 'View'" [(ngModel)]="client.renewalDaysCount" />
              </div>
            </div>
            <div class="col-md-4" *ngIf="ProductUID!='00000020-0000-0000-0000-000000000000'">
              <div class="form-group reg-static-field">
                <label>Registration Date: <strong>{{currentDate | date:'dd-MM-yyyy'}}</strong></label>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Joining Date</label> <label *ngIf="action != 'View'" class="danger">*</label>
                <div class="input-group">
                  <input class="form-control" required [disabled]="action == 'View'" [min]="getToday()"
                         placeholder="yyyy-mm-dd" name="joiningDate" [(ngModel)]="client.joiningDate"
                         #joiningDate="ngModel"
                         [ngClass]="{ 'is-invalid': clientForm.submitted && joiningDate.errors }"
                         data-date-format="DD MMMM YYYY" type="date">
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Signature</label><label *ngIf="action != 'View'" class="danger">*</label>
                <div class="custom-file">
                  <input type="file" class="custom-file-input" id="clientSignatureFile" accept="image/*" required
                         (change)="onFileChangeSignature($event.target.files)">
                  <label class="custom-file-label" for="clientSignatureFile">{{signatureChoosefile}}</label>
                </div>
              </div>
            </div>
          </div>

          <div class="reg-declaration">
            <label class="reg-check">
              <input type="checkbox" name="informationProvidedTheBestOfMyKnowledge"
                     [(ngModel)]="!client.informationProvidedTheBestOfMyKnowledge"
                     (ngModelChange)="client.informationProvidedTheBestOfMyKnowledge=!$event">
              <span>
                I hereby declare that the information provided above is true and accurate to the best of my
                knowledge.<label *ngIf="action != 'View'" class="danger">*</label>
              </span>
            </label>
            <label class="reg-check">
              <input type="checkbox" name="confidentialBusinessPurposes"
                     [(ngModel)]="!client.confidentialBusinessPurposes"
                     (ngModelChange)="client.confidentialBusinessPurposes=!$event">
              <span>
                Please fill out this form to register as a client with our company. Your information will be kept
                confidential and used solely for business purposes.<label *ngIf="action != 'View'" class="danger">*</label>
              </span>
            </label>
          </div>
        </div>

      </div>
    </div>

    <div class="modal-footer reg-modal-footer">
      <button type="button" class="btn reg-btn-ghost" (click)="closePopup(clientForm,ChangesConfirmation)">Close</button>
      <button type="submit" *ngIf="action != 'View'" class="btn reg-btn-primary">Save</button>
    </div>
  </form>
</ng-template>-->
<!-- ════════════════════════════════════════════════════════════════════════════
     ACCOUNT MODAL
     ════════════════════════════════════════════════════════════════════════════ -->
<!--<ng-template class="modal text-left" #AccountContent let-c="close" let-d="dismiss">
  <form name="accountForm" #accountForm="ngForm" (ngSubmit)="Saveaccount(accountForm)" novalidate>
    <div class="modal-header reg-modal-header">
      <h4 class="modal-title">{{action}} Account</h4>
      <button type="button" class="close" aria-label="Close" (click)="closePopup(accountForm,ChangesConfirmation)">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body reg-modal-body">
      <div class="form-body">

        <div class="reg-section">
          <h5 class="reg-section-title"><span class="reg-section-icon la la-link"></span> Link to Client</h5>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Client</label><label *ngIf="action != 'View'" class="danger">*</label>
                <select name="companyName" (change)="GetLogInDetails($event)" class="form-control"
                        [disabled]="action == 'View'" [(ngModel)]="account.clientRegistrationUId"
                        #companyName="ngModel" required
                        [ngClass]="{ 'is-invalid': accountForm.submitted && companyName.errors }">
                  <option [value]="cli.clientRegistrationUId" *ngFor="let cli of Clientregistrationlist">
                    {{cli.companyName}}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="row" *ngIf="GYMRadio">
            <div class="col-md-12">
              <div class="form-group">
                <div class="reg-radio-row">
                  <div class="d-inline-block custom-control custom-radio mr-1">
                    <input type="radio" class="custom-control-input" name="gym" value="Trainee" id="gymRoleTrainee"
                           [(ngModel)]="account.roleBasedLogedin" (change)="GetGYMLogInDetails($event)">
                    <label class="custom-control-label" for="gymRoleTrainee">Trainee</label>
                  </div>
                  <div class="d-inline-block custom-control custom-radio mr-1">
                    <input type="radio" class="custom-control-input" name="gym" value="Trainer" id="gymRoleTrainer"
                           [(ngModel)]="account.roleBasedLogedin" (change)="GetGYMLogInDetails($event)">
                    <label class="custom-control-label" for="gymRoleTrainer">Trainer</label>
                  </div>
                  <div class="d-inline-block custom-control custom-radio mr-1">
                    <input type="radio" class="custom-control-input" name="gym" value="Manager" id="gymRoleManager"
                           [(ngModel)]="account.roleBasedLogedin" (change)="GetGYMLogInDetails($event)">
                    <label class="custom-control-label" for="gymRoleManager">Manager</label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row" *ngIf="DisplayLoggedIn">
            <div class="col-md-12">
              <div class="form-group">
                <label>LoggedIn</label>
                <div>
                  <ng-select name="LoggedInName" [disabled]="(action == 'View'|| action=='Edit')"
                             (change)="getDetails($event)" [(ngModel)]="loggedInUId" [items]="LoggedInList"
                             #LoggedInName="ngModel" bindValue="value" bindLabel="Label" placeholder="Select">
                  </ng-select>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Accessrole</label><label *ngIf="action != 'View'" class="danger">*</label>
                <select name="accessRoleName" (change)="GetAccessroleUId($event)" class="form-control"
                        [disabled]="action == 'View'" [(ngModel)]="account.accessRoleUId" #accessRoleName="ngModel"
                        required [ngClass]="{ 'is-invalid': accountForm.submitted && accessRoleName.errors }">
                  <option [value]="acc.accessRoleUId" *ngFor="let acc of AccessRolelist">{{acc.accessRoleName}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="reg-section">
          <h5 class="reg-section-title"><span class="reg-section-icon la la-id-card-o"></span> Account Credentials</h5>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Name </label> <label *ngIf="action != 'View'" class="danger">*</label>
                <input type="text" class="form-control" placeholder="Enter Name " maxlength="30" #name="ngModel"
                       [ngClass]="{ 'is-invalid': accountForm.submitted && name.errors }" whiteSpaceValidator required
                       name="name" [disabled]="action == 'View'" [(ngModel)]="account.name" />
                <div *ngIf="accountForm.submitted && name.errors" class="invalid-feedback">
                  <div *ngIf="name.errors['required']"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Email </label> <label *ngIf="action != 'View'" class="danger">*</label>
                <input type="text" class="form-control" placeholder="Enter EmailID " #email="ngModel"
                       [ngClass]="{ 'is-invalid': accountForm.submitted && email.errors }"
                       pattern="^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$" maxlength="35" whiteSpaceValidator
                       email required name="email" [disabled]="action == 'View'" [(ngModel)]="account.email" />
                <div *ngIf="accountForm.submitted && email.errors" class="invalid-feedback">
                  <div *ngIf="email.errors['required']"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Mobile Number </label> <label *ngIf="action != 'View'" class="danger">*</label>
                <input type="text" class="form-control" placeholder="Enter MobileNmber" #mobileNumber="ngModel"
                       [ngClass]="{ 'is-invalid': accountForm.submitted && mobileNumber.errors }" required
                       name="mobileNumber" minlength="10" maxlength="10" whiteSpaceValidator numberValidator
                       [disabled]="action == 'View'" [(ngModel)]="account.mobileNumber" />
                <div *ngIf="accountForm.submitted && mobileNumber.errors" class="invalid-feedback">
                  <div *ngIf="mobileNumber.errors['required']"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Password</label><label *ngIf="action != 'View'" class="danger">*</label>
                <input type="password" class="form-control" required name="password" minlength="10" maxlength="15"
                       #password="ngModel" [ngClass]="{ 'is-invalid': accountForm.submitted && password.errors }"
                       whiteSpaceValidator [disabled]="action == 'View'" [(ngModel)]="account.password"
                       placeholder=" Enter Password">
                <div *ngIf="accountForm.submitted && password.errors" class="invalid-feedback">
                  <div *ngIf="password.errors['required']"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="modal-footer reg-modal-footer">
      <button type="button" class="btn reg-btn-ghost" (click)="closePopup(accountForm,ChangesConfirmation)">Close</button>
      <button type="submit" *ngIf="action != 'View'" class="btn reg-btn-primary">Save</button>
    </div>
  </form>
</ng-template>-->
<!-- ════════════════════════════════════════════════════════════════════════════
     SHARED CONFIRMATIONS (delete + unsaved changes) — one set for both entities
     ════════════════════════════════════════════════════════════════════════════ -->
<!--<ng-template class="modal text-left" #DeleteConfirmation let-c="close" let-d="dismiss">
  <div class="modal-header reg-modal-header">
    <h4 class="modal-title">Confirmation</h4>
    <button type="button" class="close" aria-label="close" (click)="d('cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Are you sure to delete this item?</p>
  </div>
  <div class="modal-footer reg-modal-footer">
    <button type="button" class="btn reg-btn-ghost" (click)="d('cross click')">No</button>
    <button type="button" class="btn reg-btn-danger" (click)="confirmDelete()">Yes, Delete</button>
  </div>
</ng-template>

<ng-template class="modal text-left ChangesConfirmation" #ChangesConfirmation let-c="close" let-d="dismiss">
  <div class="modal-header reg-modal-header">
    <h4 class="modal-title">Confirmation</h4>
    <button type="button" class="close" aria-label="close" (click)="d('cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Are you sure that you want to leave the current page? The changes that you made won't be saved.</p>
  </div>
  <div class="modal-footer reg-modal-footer">
    <button type="button" class="btn reg-btn-ghost" (click)="reopenCurrent()">No</button>
    <button type="button" class="btn reg-btn-primary" (click)="d('cross click')">Yes</button>
  </div>
</ng-template>-->
<!--<div class="auth-shell">
  <aside class="auth-brand">
    <div class="auth-brand-logo">
      <img src="assets/custom/images/abg/kg logo.jpeg" alt="KG Technologys" />
      <span>KG Technologys</span>
    </div>
    <h1 class="auth-brand-headline">Register your organization in minutes.</h1>
    <p class="auth-brand-sub">
      Create your admin account, add your company details, pick a product, and verify by email —
      your tenant is provisioned automatically.
    </p>
    <ul class="auth-brand-features">
      <li><i class="la la-user-plus"></i> Self-service organization onboarding</li>
      <li><i class="la la-building"></i> Complete company &amp; contact profile</li>
      <li><i class="la la-th-large"></i> One product, dynamically configured</li>
      <li><i class="la la-shield"></i> OTP-verified, isolated per tenant</li>
    </ul>
    <div class="auth-brand-footer">&copy; KG Technologys. All rights reserved.</div>
  </aside>

  <main class="auth-main">
    <div class="auth-card auth-card--wide">
      <div class="auth-mobile-logo">
        <img src="assets/custom/images/abg/kg logo.jpeg" alt="KG Technologys" />
      </div>-->
<!-- Stepper (4 steps) -->
<!--<div class="auth-stepper">
  <div class="auth-step" [ngClass]="{ active: step === 1, done: step > 1 }" (click)="goToStep(1)">
    <span class="auth-step-dot"><i class="la" [ngClass]="step > 1 ? 'la-check' : 'la-user'"></i></span>
    <span class="auth-step-label">Account</span>
  </div>
  <div class="auth-step-line" [ngClass]="{ done: step > 1 }"></div>
  <div class="auth-step" [ngClass]="{ active: step === 2, done: step > 2 }" (click)="goToStep(2)">
    <span class="auth-step-dot"><i class="la" [ngClass]="step > 2 ? 'la-check' : 'la-building'"></i></span>
    <span class="auth-step-label">Company</span>
  </div>
  <div class="auth-step-line" [ngClass]="{ done: step > 2 }"></div>
  <div class="auth-step" [ngClass]="{ active: step === 3, done: step > 3 }" (click)="goToStep(3)">
    <span class="auth-step-dot"><i class="la" [ngClass]="step > 3 ? 'la-check' : 'la-th-large'"></i></span>
    <span class="auth-step-label">Product</span>
  </div>
  <div class="auth-step-line" [ngClass]="{ done: step > 3 }"></div>
  <div class="auth-step" [ngClass]="{ active: step === 4 }">
    <span class="auth-step-dot"><i class="la la-shield"></i></span>
    <span class="auth-step-label">Verify</span>
  </div>
</div>

<div class="auth-banner auth-banner--error" *ngIf="errorMessage">
  <i class="la la-exclamation-circle"></i> <span>{{ errorMessage }}</span>
</div>
<div class="auth-banner auth-banner--success" *ngIf="successMessage">
  <i class="la la-check-circle"></i> <span>{{ successMessage }}</span>
</div>-->
<!-- ================= STEP 1: ACCOUNT ================= -->
<!--<form [formGroup]="accountForm" (ngSubmit)="submitAccount()" *ngIf="step === 1" novalidate>
  <h2 class="auth-title">Create your admin account</h2>
  <p class="auth-sub">This person becomes the organization administrator.</p>

  <div class="auth-field">
    <label class="auth-label">Full name</label>
    <div class="auth-input-wrap">
      <input type="text" class="auth-input" formControlName="fullName" placeholder="Your full name"
             [ngClass]="{ 'is-invalid': accSubmitted && rf.fullName.errors }" />
      <i class="auth-input-icon la la-user"></i>
    </div>
    <div class="auth-error" *ngIf="accSubmitted && rf.fullName.errors?.required">Full name is required</div>
  </div>

  <div class="auth-grid-2">
    <div class="auth-field">
      <label class="auth-label">Email address</label>
      <div class="auth-input-wrap">
        <input type="email" class="auth-input" formControlName="email" placeholder="you@example.com"
               [ngClass]="{ 'is-invalid': accSubmitted && rf.email.errors }" />
        <i class="auth-input-icon la la-envelope"></i>
      </div>
      <div class="auth-error" *ngIf="accSubmitted && rf.email.errors?.required">Email is required</div>
      <div class="auth-error" *ngIf="accSubmitted && rf.email.errors?.email">Enter a valid email</div>
    </div>

    <div class="auth-field">
      <label class="auth-label">Mobile number</label>
      <div class="auth-input-wrap">
        <input type="text" class="auth-input" formControlName="mobile" placeholder="10-digit mobile" maxlength="10"
               [ngClass]="{ 'is-invalid': accSubmitted && rf.mobile.errors }" />
        <i class="auth-input-icon la la-mobile"></i>
      </div>
      <div class="auth-error" *ngIf="accSubmitted && rf.mobile.errors?.required">Mobile is required</div>
      <div class="auth-error" *ngIf="accSubmitted && (rf.mobile.errors?.minlength || rf.mobile.errors?.pattern)">Enter a valid 10-digit number</div>
    </div>
  </div>

  <div class="auth-field">
    <label class="auth-label">Password</label>
    <div class="auth-input-wrap">
      <input [type]="showPassword ? 'text' : 'password'" class="auth-input auth-input--with-trail"
             formControlName="password" placeholder="Create a password" (input)="onPasswordChange()"
             [ngClass]="{ 'is-invalid': accSubmitted && rf.password.errors }" />
      <i class="auth-input-icon la la-lock"></i>
      <button type="button" class="auth-input-trail" (click)="showPassword = !showPassword">
        <i class="la" [ngClass]="showPassword ? 'la-eye-slash' : 'la-eye'"></i>
      </button>
    </div>
    <div class="auth-strength" *ngIf="rf.password.value">
      <span class="auth-strength-bar" [ngClass]="passwordStrength >= 1 ? strengthClass : ''"></span>
      <span class="auth-strength-bar" [ngClass]="passwordStrength >= 2 ? strengthClass : ''"></span>
      <span class="auth-strength-bar" [ngClass]="passwordStrength >= 3 ? strengthClass : ''"></span>
    </div>
    <div class="auth-error" *ngIf="accSubmitted && rf.password.errors?.required">Password is required</div>
    <div class="auth-error" *ngIf="accSubmitted && rf.password.errors?.minlength">At least 8 characters</div>
  </div>

  <label class="auth-terms">
    <input type="checkbox" formControlName="acceptTerms" />
    <span>I accept the Terms &amp; Conditions</span>
  </label>
  <div class="auth-error" *ngIf="accSubmitted && rf.acceptTerms.errors?.required">Please accept the Terms &amp; Conditions.</div>

  <button type="submit" class="auth-btn auth-btn-primary"><span>Continue</span></button>
  <p class="auth-foot">Already have an account? <a [routerLink]="['/login']" class="auth-link">Sign in</a></p>
</form>-->
<!-- ================= STEP 2: COMPANY ================= -->
<!--<form [formGroup]="companyForm" (ngSubmit)="submitCompany()" *ngIf="step === 2" novalidate>
  <h2 class="auth-title">Company details</h2>
  <p class="auth-sub">Tell us about your organization. Tenant ID &amp; Registration No. are generated for you.</p>

  <h3 class="auth-section-title">Company information</h3>
  <div class="auth-grid-2">
    <div class="auth-field">
      <label class="auth-label">Company name <span class="auth-req">*</span></label>
      <input type="text" class="auth-input" formControlName="companyName" placeholder="Registered company name"
             [ngClass]="{ 'is-invalid': coSubmitted && cf.companyName.errors }" />
      <div class="auth-error" *ngIf="coSubmitted && cf.companyName.errors?.required">Company name is required</div>
    </div>
    <div class="auth-field">
      <label class="auth-label">Legal name</label>
      <input type="text" class="auth-input" formControlName="companyLegalName" placeholder="Legal / trade name" />
    </div>
    <div class="auth-field">
      <label class="auth-label">Company type</label>
      <select class="auth-input" formControlName="companyType">
        <option value="">Select type</option>
        <option *ngFor="let t of companyTypes" [value]="t">{{ t }}</option>
      </select>
    </div>
    <div class="auth-field">
      <label class="auth-label">Industry</label>
      <select class="auth-input" formControlName="industry">
        <option value="">Select industry</option>
        <option *ngFor="let i of industries" [value]="i">{{ i }}</option>
      </select>
    </div>
    <div class="auth-field">
      <label class="auth-label">Registration number</label>
      <input type="text" class="auth-input" formControlName="companyRegistrationNumber" placeholder="Company reg. no." />
    </div>
    <div class="auth-field">
      <label class="auth-label">CIN number</label>
      <input type="text" class="auth-input" formControlName="cinNumber" placeholder="21-char CIN (optional)" />
    </div>
    <div class="auth-field">
      <label class="auth-label">GST number</label>
      <input type="text" class="auth-input" formControlName="gstNumber" placeholder="15-char GSTIN" maxlength="15"
             [ngClass]="{ 'is-invalid': cf.gstNumber.value && cf.gstNumber.errors }" />
      <div class="auth-error" *ngIf="cf.gstNumber.value && cf.gstNumber.errors?.pattern">Invalid GSTIN format</div>
    </div>
    <div class="auth-field">
      <label class="auth-label">PAN number</label>
      <input type="text" class="auth-input" formControlName="panNumber" placeholder="AAAAA9999A" maxlength="10"
             [ngClass]="{ 'is-invalid': cf.panNumber.value && cf.panNumber.errors }" />
      <div class="auth-error" *ngIf="cf.panNumber.value && cf.panNumber.errors?.pattern">Invalid PAN format</div>
    </div>
    <div class="auth-field">
      <label class="auth-label">MSME / UDYAM</label>
      <input type="text" class="auth-input" formControlName="msmeUdyamNumber" placeholder="UDYAM number (optional)" />
    </div>
    <div class="auth-field">
      <label class="auth-label">IEC number</label>
      <input type="text" class="auth-input" formControlName="iecNumber" placeholder="IEC (optional)" />
    </div>
  </div>

  <h3 class="auth-section-title">Contact &amp; address</h3>
  <div class="auth-grid-2">
    <div class="auth-field">
      <label class="auth-label">Company email <span class="auth-req">*</span></label>
      <input type="email" class="auth-input" formControlName="companyEmail" placeholder="info@company.com"
             [ngClass]="{ 'is-invalid': coSubmitted && cf.companyEmail.errors }" />
      <div class="auth-error" *ngIf="coSubmitted && cf.companyEmail.errors">Enter a valid company email</div>
    </div>
    <div class="auth-field">
      <label class="auth-label">Company phone <span class="auth-req">*</span></label>
      <input type="text" class="auth-input" formControlName="companyPhone" placeholder="Phone"
             [ngClass]="{ 'is-invalid': coSubmitted && cf.companyPhone.errors }" />
      <div class="auth-error" *ngIf="coSubmitted && cf.companyPhone.errors">At least 10 digits</div>
    </div>
    <div class="auth-field">
      <label class="auth-label">Alternate phone</label>
      <input type="text" class="auth-input" formControlName="alternatePhone" placeholder="Optional" />
    </div>
    <div class="auth-field">
      <label class="auth-label">Website</label>
      <input type="text" class="auth-input" formControlName="companyWebsite" placeholder="https://" />
    </div>
    <div class="auth-field auth-col-span-2">
      <label class="auth-label">Address</label>
      <input type="text" class="auth-input" formControlName="companyAddress" placeholder="Street / building" />
    </div>
    <div class="auth-field">
      <label class="auth-label">City</label>
      <input type="text" class="auth-input" formControlName="city" placeholder="City" />
    </div>
    <div class="auth-field">
      <label class="auth-label">State</label>
      <input type="text" class="auth-input" formControlName="state" placeholder="State" />
    </div>
    <div class="auth-field">
      <label class="auth-label">Country</label>
      <input type="text" class="auth-input" formControlName="country" placeholder="Country" />
    </div>
    <div class="auth-field">
      <label class="auth-label">PIN code</label>
      <input type="text" class="auth-input" formControlName="pinCode" placeholder="6-digit PIN" maxlength="6"
             [ngClass]="{ 'is-invalid': cf.pinCode.value && cf.pinCode.errors }" />
      <div class="auth-error" *ngIf="cf.pinCode.value && cf.pinCode.errors?.pattern">Invalid PIN code</div>
    </div>
  </div>

  <h3 class="auth-section-title">Contact person</h3>
  <div class="auth-grid-2">
    <div class="auth-field">
      <label class="auth-label">Full name <span class="auth-req">*</span></label>
      <input type="text" class="auth-input" formControlName="contactFullName" placeholder="Contact person"
             [ngClass]="{ 'is-invalid': coSubmitted && cf.contactFullName.errors }" />
      <div class="auth-error" *ngIf="coSubmitted && cf.contactFullName.errors?.required">Contact name is required</div>
    </div>
    <div class="auth-field">
      <label class="auth-label">Designation</label>
      <input type="text" class="auth-input" formControlName="contactDesignation" placeholder="e.g. Director" />
    </div>
    <div class="auth-field">
      <label class="auth-label">Mobile <span class="auth-req">*</span></label>
      <input type="text" class="auth-input" formControlName="contactMobile" placeholder="Mobile"
             [ngClass]="{ 'is-invalid': coSubmitted && cf.contactMobile.errors }" />
      <div class="auth-error" *ngIf="coSubmitted && cf.contactMobile.errors">At least 10 digits</div>
    </div>
    <div class="auth-field">
      <label class="auth-label">Email</label>
      <input type="email" class="auth-input" formControlName="contactEmail" placeholder="Optional"
             [ngClass]="{ 'is-invalid': cf.contactEmail.value && cf.contactEmail.errors }" />
    </div>
    <div class="auth-field">
      <label class="auth-label">Alternate contact</label>
      <input type="text" class="auth-input" formControlName="alternateContact" placeholder="Optional" />
    </div>
  </div>

  <h3 class="auth-section-title">Subscription</h3>
  <div class="auth-grid-2">
    <div class="auth-field">
      <label class="auth-label">License type</label>
      <select class="auth-input" formControlName="licenseType">
        <option *ngFor="let l of licenseTypes" [value]="l">{{ l }}</option>
      </select>
    </div>
    <div class="auth-field">
      <label class="auth-label">Subscription plan</label>
      <select class="auth-input" formControlName="subscriptionPlan">
        <option *ngFor="let p of subscriptionPlans" [value]="p">{{ p }}</option>
      </select>
    </div>
  </div>

  <div class="auth-actions">
    <button type="button" class="auth-btn auth-btn-ghost" (click)="step = 1">&larr; Back</button>
    <button type="submit" class="auth-btn auth-btn-primary"><span>Continue</span></button>
  </div>
</form>-->
<!-- ================= STEP 3: PRODUCT ================= -->
<!--<div *ngIf="step === 3">
  <h2 class="auth-title">Choose your product</h2>
  <p class="auth-sub">This drives your menus, modules, dashboards and permissions after login.</p>

  <div class="auth-product-grid">
    <button type="button" class="auth-product-card" *ngFor="let p of products"
            [ngClass]="{ selected: isProductSelected(p.id) }" (click)="toggleProduct(p.id)">
      <span class="auth-product-icon" [ngClass]="p.cssClass"><i class="la" [ngClass]="p.icon"></i></span>
      <span class="auth-product-name">{{ p.name }}</span>
      <span class="auth-product-check"><i class="la la-check"></i></span>
    </button>
  </div>

  <div class="auth-actions">
    <button type="button" class="auth-btn auth-btn-ghost" (click)="step = 2">&larr; Back</button>
    <button type="button" class="auth-btn auth-btn-primary"
            [disabled]="loading || selectedProducts.length === 0" (click)="finishRegistration()">
      <i class="fa fa-refresh fa-spin" *ngIf="loading"></i>
      <span>{{ loading ? 'Sending code...' : 'Send verification code' }}</span>
    </button>
  </div>
</div>-->
<!-- ================= STEP 4: VERIFY ================= -->
<!--<div *ngIf="step === 4">
        <h2 class="auth-title">Verify your email</h2>
        <p class="auth-sub">We sent a 6-digit code to <strong>{{ accountForm.value.email }}</strong>.</p>

        <div class="auth-otp-group">
          <input *ngFor="let box of otpBoxes; let i = index" #otpInput type="tel" inputmode="numeric" maxlength="1"
                 class="auth-otp-input" [ngClass]="{ filled: otpDigits[i] }" [value]="otpDigits[i] || ''"
                 (input)="onOtpInput($event, i)" (keydown)="onOtpKeydown($event, i)" (paste)="onOtpPaste($event)" />
        </div>

        <div class="auth-resend">
          Didn't get it?
          <button type="button" class="auth-link" [disabled]="resendCountdown > 0" (click)="resendOtp()">
            Resend code <span *ngIf="resendCountdown > 0">({{ resendCountdown }}s)</span>
          </button>
        </div>

        <button type="button" class="auth-btn auth-btn-primary" [disabled]="loading || !isOtpComplete()" (click)="verifyOtp()">
          <i class="fa fa-refresh fa-spin" *ngIf="loading"></i>
          <span>{{ loading ? 'Creating your organization...' : 'Verify &amp; finish' }}</span>
        </button>

        <p class="auth-foot"><a class="auth-link" (click)="step = 3">&larr; Change product</a></p>
      </div>
    </div>
  </main>
</div>-->


<div class="app-content content">
  <div class="content-overlay"></div>
  <div class="content-wrapper">
    <div class="content-header row">
    </div>
    <div class="content-body">
      <section class="row flexbox-container">
        <div class="col-12 d-flex align-items-center justify-content-center">
          <div class="col-lg-7 col-md-10 col-11 box-shadow-2 p-0">
            <div class="card border-grey border-lighten-3 px-1 py-1 m-0">
              <div class="card-header border-0">
                <div class="card-title text-center">
                  <img src="assets/custom/images/abg/kg logo.jpeg" alt="branding logo">
                </div>
              </div>
              <div class="card-content">
                <div class="card-body pt-0">

                  <!-- Stepper -->
                  <ul class="nav nav-pills nav-justified reg-steps mb-2">
                    <li class="nav-item">
                      <a class="nav-link" [ngClass]="{ active: step === 1, done: step > 1 }" (click)="goToStep(1)">
                        <i class="la" [ngClass]="step > 1 ? 'la-check' : 'la-user'"></i> Account
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" [ngClass]="{ active: step === 2, done: step > 2 }" (click)="goToStep(2)">
                        <i class="la" [ngClass]="step > 2 ? 'la-check' : 'la-building'"></i> Company
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" [ngClass]="{ active: step === 3, done: step > 3 }" (click)="goToStep(3)">
                        <i class="la" [ngClass]="step > 3 ? 'la-check' : 'la-th-large'"></i> Product
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" [ngClass]="{ active: step === 4 }">
                        <i class="la la-shield"></i> Verify
                      </a>
                    </li>
                  </ul>

                  <div *ngIf="errorMessage" class="alert alert-danger" role="alert">{{ errorMessage }}</div>
                  <div *ngIf="successMessage" class="alert alert-success" role="alert">{{ successMessage }}</div>

                  <!-- ================= STEP 1: ACCOUNT ================= -->
                  <form class="form-horizontal" [formGroup]="accountForm" (ngSubmit)="submitAccount()" *ngIf="step === 1" novalidate>
                    <p class="text-muted text-center mb-2">This person becomes the organization administrator.</p>

                    <fieldset class="form-group position-relative has-icon-left">
                      <input type="text" formControlName="fullName" class="form-control"
                             [ngClass]="{ 'is-invalid': accSubmitted && rf.fullName.errors }"
                             placeholder="Your full name">
                      <div class="form-control-position"><i class="la la-user"></i></div>
                      <div *ngIf="accSubmitted && rf.fullName.errors" class="invalid-feedback">
                        <div *ngIf="rf.fullName.errors.required">Full name is required</div>
                      </div>
                    </fieldset>

                    <div class="form-group row">
                      <div class="col-md-6">
                        <fieldset class="form-group position-relative has-icon-left mb-md-0">
                          <input type="email" formControlName="email" class="form-control"
                                 [ngClass]="{ 'is-invalid': accSubmitted && rf.email.errors }"
                                 placeholder="you@example.com">
                          <div class="form-control-position"><i class="la la-envelope"></i></div>
                          <div *ngIf="accSubmitted && rf.email.errors" class="invalid-feedback">
                            <div *ngIf="rf.email.errors.required">Email is required</div>
                            <div *ngIf="rf.email.errors.email">Enter a valid email</div>
                          </div>
                        </fieldset>
                      </div>
                      <div class="col-md-6">
                        <fieldset class="form-group position-relative has-icon-left mb-md-0">
                          <input type="text" formControlName="mobile" class="form-control" maxlength="10"
                                 [ngClass]="{ 'is-invalid': accSubmitted && rf.mobile.errors }"
                                 placeholder="10-digit mobile">
                          <div class="form-control-position"><i class="la la-mobile"></i></div>
                          <div *ngIf="accSubmitted && rf.mobile.errors" class="invalid-feedback">
                            <div *ngIf="rf.mobile.errors.required">Mobile is required</div>
                            <div *ngIf="rf.mobile.errors.minlength || rf.mobile.errors.pattern">Enter a valid 10-digit number</div>
                          </div>
                        </fieldset>
                      </div>
                    </div>

                    <fieldset class="form-group position-relative has-icon-left">
                      <input [type]="showPassword ? 'text' : 'password'" formControlName="password" class="form-control"
                             [ngClass]="{ 'is-invalid': accSubmitted && rf.password.errors }"
                             placeholder="Create a password" (input)="onPasswordChange()">
                      <div class="form-control-position"><i class="la la-lock"></i></div>
                      <a href="javascript:void(0)" class="reg-pw-toggle" (click)="showPassword = !showPassword">
                        <i class="la" [ngClass]="showPassword ? 'la-eye-slash' : 'la-eye'"></i>
                      </a>
                      <div class="reg-strength" *ngIf="rf.password.value">
                        <span class="reg-strength-bar" [ngClass]="passwordStrength >= 1 ? strengthClass : ''"></span>
                        <span class="reg-strength-bar" [ngClass]="passwordStrength >= 2 ? strengthClass : ''"></span>
                        <span class="reg-strength-bar" [ngClass]="passwordStrength >= 3 ? strengthClass : ''"></span>
                      </div>
                      <div *ngIf="accSubmitted && rf.password.errors" class="invalid-feedback d-block">
                        <div *ngIf="rf.password.errors.required">Password is required</div>
                        <div *ngIf="rf.password.errors.minlength">At least 8 characters</div>
                      </div>
                    </fieldset>

                    <fieldset class="form-group position-relative has-icon-left">
                      <input type="text" formControlName="referralCode" class="form-control"
                             placeholder="Referral code (optional)">
                      <div class="form-control-position"><i class="la la-gift"></i></div>
                    </fieldset>

                    <div class="form-group">
                      <div class="form-check">
                        <input type="checkbox" class="form-check-input" formControlName="acceptTerms" id="accept-terms">
                        <label class="form-check-label" for="accept-terms">I accept the Terms &amp; Conditions</label>
                      </div>
                      <div *ngIf="accSubmitted && rf.acceptTerms.errors" class="invalid-feedback d-block">
                        Please accept the Terms &amp; Conditions.
                      </div>
                    </div>

                    <button type="submit" class="btn btn-outline-info btn-block">
                      <i class="feather ft-arrow-right"></i> Continue
                    </button>
                  </form>

                  <!-- ================= STEP 2: COMPANY ================= -->
                  <form class="form-horizontal" [formGroup]="companyForm" (ngSubmit)="submitCompany()" *ngIf="step === 2" novalidate>
                    <p class="text-muted text-center mb-2">Tenant ID &amp; Registration No. are generated for you.</p>

                    <h6 class="reg-section-title">Company information</h6>
                    <div class="form-group row">
                      <div class="col-md-6">
                        <label>Company name <span class="reg-req">*</span></label>
                        <input type="text" formControlName="companyName" class="form-control"
                               [ngClass]="{ 'is-invalid': coSubmitted && cf.companyName.errors }"
                               placeholder="Registered company name">
                        <div *ngIf="coSubmitted && cf.companyName.errors" class="invalid-feedback">
                          <div *ngIf="cf.companyName.errors.required">Company name is required</div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <label>Legal name</label>
                        <input type="text" formControlName="companyLegalName" class="form-control" placeholder="Legal / trade name">
                      </div>
                      <div class="col-md-6">
                        <label>Company type</label>
                        <select class="form-control" formControlName="companyType">
                          <option value="">Select type</option>
                          <option *ngFor="let t of companyTypes" [value]="t">{{ t }}</option>
                        </select>
                      </div>
                      <div class="col-md-6">
                        <label>Industry</label>
                        <select class="form-control" formControlName="industry">
                          <option value="">Select industry</option>
                          <option *ngFor="let i of industries" [value]="i">{{ i }}</option>
                        </select>
                      </div>
                      <div class="col-md-6">
                        <label>Registration number</label>
                        <input type="text" formControlName="companyRegistrationNumber" class="form-control" placeholder="Company reg. no.">
                      </div>
                      <div class="col-md-6">
                        <label>CIN number</label>
                        <input type="text" formControlName="cinNumber" class="form-control" placeholder="21-char CIN (optional)">
                      </div>
                      <div class="col-md-6">
                        <label>GST number</label>
                        <input type="text" formControlName="gstNumber" class="form-control" maxlength="15"
                               [ngClass]="{ 'is-invalid': cf.gstNumber.value && cf.gstNumber.errors }"
                               placeholder="15-char GSTIN">
                        <div *ngIf="cf.gstNumber.value && cf.gstNumber.errors" class="invalid-feedback">Invalid GSTIN format</div>
                      </div>
                      <div class="col-md-6">
                        <label>PAN number</label>
                        <input type="text" formControlName="panNumber" class="form-control" maxlength="10"
                               [ngClass]="{ 'is-invalid': cf.panNumber.value && cf.panNumber.errors }"
                               placeholder="AAAAA9999A">
                        <div *ngIf="cf.panNumber.value && cf.panNumber.errors" class="invalid-feedback">Invalid PAN format</div>
                      </div>
                      <div class="col-md-6">
                        <label>MSME / UDYAM</label>
                        <input type="text" formControlName="msmeUdyamNumber" class="form-control" placeholder="UDYAM number (optional)">
                      </div>
                      <div class="col-md-6">
                        <label>IEC number</label>
                        <input type="text" formControlName="iecNumber" class="form-control" placeholder="IEC (optional)">
                      </div>
                    </div>

                    <h6 class="reg-section-title">Contact &amp; address</h6>
                    <div class="form-group row">
                      <div class="col-md-6">
                        <label>Company email <span class="reg-req">*</span></label>
                        <input type="email" formControlName="companyEmail" class="form-control"
                               [ngClass]="{ 'is-invalid': coSubmitted && cf.companyEmail.errors }"
                               placeholder="info@company.com">
                        <div *ngIf="coSubmitted && cf.companyEmail.errors" class="invalid-feedback">Enter a valid company email</div>
                      </div>
                      <div class="col-md-6">
                        <label>Company phone <span class="reg-req">*</span></label>
                        <input type="text" formControlName="companyPhone" class="form-control"
                               [ngClass]="{ 'is-invalid': coSubmitted && cf.companyPhone.errors }"
                               placeholder="Phone">
                        <div *ngIf="coSubmitted && cf.companyPhone.errors" class="invalid-feedback">At least 10 digits</div>
                      </div>
                      <div class="col-md-6">
                        <label>Alternate phone</label>
                        <input type="text" formControlName="alternatePhone" class="form-control" placeholder="Optional">
                      </div>
                      <div class="col-md-6">
                        <label>Website</label>
                        <input type="text" formControlName="companyWebsite" class="form-control" placeholder="https://">
                      </div>
                      <div class="col-md-12">
                        <label>Address</label>
                        <input type="text" formControlName="companyAddress" class="form-control" placeholder="Street / building">
                      </div>
                      <div class="col-md-6">
                        <label>City<span class="reg-req">*</span></label>
                        <input type="text" formControlName="city" class="form-control" placeholder="City">
                      </div>
                      <div class="col-md-6">
                        <label>State<span class="reg-req">*</span></label>
                        <input type="text" formControlName="state" class="form-control" placeholder="State">
                      </div>
                      <div class="col-md-6">
                        <label>Country<span class="reg-req">*</span></label>
                        <input type="text" formControlName="country" class="form-control" placeholder="Country">
                      </div>
                      <div class="col-md-6">
                        <label>PIN code<span class="reg-req">*</span></label>
                        <input type="text" formControlName="pinCode" class="form-control" maxlength="6"
                               [ngClass]="{ 'is-invalid': cf.pinCode.value && cf.pinCode.errors }"
                               placeholder="6-digit PIN">
                        <div *ngIf="cf.pinCode.value && cf.pinCode.errors" class="invalid-feedback">Invalid PIN code</div>
                      </div>
                    </div>

                    <h6 class="reg-section-title">Contact person</h6>
                    <div class="form-group row">
                      <div class="col-md-6">
                        <label>Full name <span class="reg-req">*</span></label>
                        <input type="text" formControlName="contactFullName" class="form-control"
                               [ngClass]="{ 'is-invalid': coSubmitted && cf.contactFullName.errors }"
                               placeholder="Contact person">
                        <div *ngIf="coSubmitted && cf.contactFullName.errors" class="invalid-feedback">Contact name is required</div>
                      </div>
                      <div class="col-md-6">
                        <label>Designation</label>
                        <input type="text" formControlName="contactDesignation" class="form-control" placeholder="e.g. Director">
                      </div>
                      <div class="col-md-6">
                        <label>Mobile <span class="reg-req">*</span></label>
                        <input type="text" formControlName="contactMobile" class="form-control"
                               [ngClass]="{ 'is-invalid': coSubmitted && cf.contactMobile.errors }"
                               placeholder="Mobile">
                        <div *ngIf="coSubmitted && cf.contactMobile.errors" class="invalid-feedback">At least 10 digits</div>
                      </div>
                      <div class="col-md-6">
                        <label>Email</label>
                        <input type="email" formControlName="contactEmail" class="form-control"
                               [ngClass]="{ 'is-invalid': cf.contactEmail.value && cf.contactEmail.errors }"
                               placeholder="Optional">
                      </div>
                      <div class="col-md-6">
                        <label>Alternate contact</label>
                        <input type="text" formControlName="alternateContact" class="form-control" placeholder="Optional">
                      </div>
                    </div>

                    <h6 class="reg-section-title">Subscription</h6>
                    <div class="form-group row">
                      <div class="col-md-6">
                        <label>License type<span class="reg-req">*</span></label>
                        <select class="form-control" formControlName="licenseType">
                          <option *ngFor="let l of licenseTypes" [value]="l">{{ l }}</option>
                        </select>
                      </div>
                      <div class="col-md-6">
                        <label>Subscription plan<span class="reg-req">*</span></label>
                        <select class="form-control" formControlName="subscriptionPlan">
                          <option *ngFor="let p of subscriptionPlans" [value]="p">{{ p }}</option>
                        </select>
                      </div>
                    </div>

                    <div class="form-group row">
                      <div class="col-6">
                        <button type="button" class="btn btn-outline-secondary btn-block" (click)="step = 1">
                          <i class="feather ft-arrow-left"></i> Back
                        </button>
                      </div>
                      <div class="col-6">
                        <button type="submit" class="btn btn-outline-info btn-block">
                          Continue <i class="feather ft-arrow-right"></i>
                        </button>
                      </div>
                    </div>
                  </form>

                  <!-- ================= STEP 3: PRODUCT ================= -->
                  <div *ngIf="step === 3">
                    <p class="text-muted text-center mb-2">This drives your menus, modules, dashboards and permissions after login.</p>

                    <div class="row">
                      <div class="col-md-4 col-6 mb-1" *ngFor="let p of products">
                        <button type="button" class="btn btn-outline-secondary btn-block reg-product-card"
                                [ngClass]="{ 'reg-product-selected': isProductSelected(p.id) }"
                                (click)="toggleProduct(p.id)">
                          <i class="la" [ngClass]="p.icon"></i>
                          <span class="reg-product-name">{{ p.name }}</span>
                          <i class="la la-check-circle reg-product-check" *ngIf="isProductSelected(p.id)"></i>
                        </button>
                      </div>
                    </div>

                    <div class="form-group row">
                      <div class="col-6">
                        <button type="button" class="btn btn-outline-secondary btn-block" (click)="step = 2">
                          <i class="feather ft-arrow-left"></i> Back
                        </button>
                      </div>
                      <div class="col-6">
                        <button type="button" class="btn btn-outline-info btn-block"
                                [disabled]="loading || selectedProducts.length === 0" (click)="finishRegistration()">
                          <i class="fa fa-refresh fa-spin" *ngIf="loading"></i>
                          <span>{{ loading ? 'Sending code...' : 'Send verification code' }}</span>
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- ================= STEP 4: VERIFY ================= -->
                  <div *ngIf="step === 4">
                    <p class="text-muted text-center mb-2">We sent a 6-digit code to <strong>{{ accountForm.value.email }}</strong>.</p>

                    <div class="reg-otp-group">
                      <input *ngFor="let box of otpBoxes; let i = index" #otpInput type="tel" inputmode="numeric" maxlength="1"
                             class="form-control reg-otp-input" [ngClass]="{ 'reg-otp-filled': otpDigits[i] }"
                             [value]="otpDigits[i] || ''"
                             (input)="onOtpInput($event, i)" (keydown)="onOtpKeydown($event, i)" (paste)="onOtpPaste($event)" />
                    </div>

                    <p class="text-center text-muted mt-2">
                      Didn't get it?
                      <a href="javascript:void(0)" class="card-link" [class.disabled]="resendCountdown > 0" (click)="resendOtp()">
                        Resend code <span *ngIf="resendCountdown > 0">({{ resendCountdown }}s)</span>
                      </a>
                    </p>

                    <button type="button" class="btn btn-outline-info btn-block" [disabled]="loading || !isOtpComplete()" (click)="verifyOtp()">
                      <i class="fa fa-refresh fa-spin" *ngIf="loading"></i>
                      <span>{{ loading ? 'Creating your organization...' : 'Verify & finish' }}</span>
                    </button>

                    <p class="card-subtitle text-center font-small-3 mx-2 my-1">
                      <a href="javascript:void(0)" class="card-link" (click)="step = 3">
                        <i class="feather ft-arrow-left"></i> Change product
                      </a>
                    </p>
                  </div>

                </div>
                <p class="card-subtitle line-on-side text-muted text-center font-small-3 mx-2 my-1" *ngIf="step === 1">
                  <span>Already have an account?</span>
                </p>
                <div class="card-body" *ngIf="step === 1">
                  <a [routerLink]="['/login']" class="btn btn-outline-danger btn-block"><i class="la la-lock"></i> Sign in</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>


